export default {
   config: {
      formats: {
         longDate: "dd MMM yyyy, HH:mm",
         shortDate: "dd MMM yyyy",
         forMomentShortDate: 'D MMM YYYY',
         ISO8601Format: "YYYY-MM-DDTHH:mm:ss.sssZ"
      }
   },
   install: function (Vue) {
      Object.defineProperty(Vue.prototype, '$timeConfig', {
         value: this.config
      });
   }
}


// WEBPACK FOOTER //
// ./src/infrastructure/timeConfig.js